import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons';

const TruckIcon = () => {
  return (
    <FontAwesomeIcon className='mx-2' icon={faTruck} />
  );
};

export default TruckIcon;
